import React, { useEffect, useState} from 'react';

import './InputField.css';

const InputField = (props) => {

  const [ state, setState ] = useState({
    validation: props.validations,
    error: props.error,
    type: props.type,
    loading: false,
    disabled: false,
    showValidations: false,

  });
  const [ value, setValue ] = useState(props.value);

  useEffect(() => {
    setState({ ...state, error: props.error });
  }, [props])

  const handleFocusIn = () => {
    setState({ ...state, showValidations: true, error: false });
  };

  const handleInput = (event) => {
    const { validation } = state;
    const value = event.target.value;
    setValue(value);
    if (validation) {
      const validations = validation.map((item) => ({ ...item, validated: item.regex.test(value) }));
      setState({ ...state, validation: validations });
    }
  };

  const showValue = () => {
    const fieldType = state.type === 'password' ? 'text' : 'password';
    setState({ ...state, type: fieldType });
  };

  const changeValue = (event) => {
    setState({ ...state, showValidations: false, error: false });
    props.changeValue(event.target.value.trim());
  };

    const {
      placeholder,
      errorMsg,
      link,
      hintText,
      label,
      prefixCode,
      eyeIcon,
      className,
      maxLength,
    } = props;
    const {
      error,
      type,
      validation,
      showValidations,
      loading,
    } = state;
    return (
      <div
        className={`makeFlex column inputFieldContainer ${
          error ? 'errorField' : ''
        }`}
      >
        <label className="latoBold appendBottom15 font14 defaultGreyText">
          {label}
        </label>
        {prefixCode && (
          <span className="font14 lightGreyText prefixedCode">
            {prefixCode}
          </span>
        )}
        {value && eyeIcon && (
          <a
            className="railSprite eyeicon"
            onClick={showValue}
          />
        )}
        {loading && <span className="blueLoader" />}
        <input
          value={value}
          type={type}
          placeholder={placeholder}
          maxLength={maxLength}
          className={`inputField ${
            prefixCode ? 'prefixed' : ''
          } ${className}`}
          onFocus={handleFocusIn}
          onInput={handleInput}
          disabled={loading}
          onBlur={changeValue}
        />
        {hintText && (
          <span className="appendTop10 font12 defaultGreyText">
            {hintText}
          </span>
        )}
        <span className="font12 errorText">{errorMsg}</span>
        {link && (
          <span className="latoBold appendTop15 font14">
            <a>{link}</a>
          </span>
        )}
        {validation && validation.length && showValidations && (
          <ul className="formValidations">
            {validation.map((item, index) => {
              return (
                <li
                  className="makeFlex hrtlCenter appendBottom10"
                  key={index}
                >
                  <span
                    className={`tickIcon appendRight10 ${
                      item.validated ? 'validated' : ''
                    }`}
                  />
                  <span className="lightGreyText font14">
                    {item.text}
                  </span>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    );
  }

  export default InputField;
